import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import UsernameField from '../../form-fields/upload/username'
import { CreationToolUploadContext } from '../manager'

const Username = styled(UsernameField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadUsernameField = ({ className, field }: Props) => {
    const { username, setUsername } = useContext(CreationToolUploadContext)

    function onChange(value: string) {
        const trimmed = value.trim()
        const noSymbol = trimmed.indexOf('@') === 0 ? trimmed.substring(1) : trimmed

        setUsername(noSymbol)
    }

    return (
        <Username
            {...{
                className,
                field,
                username,
                showInstructions: true,
                onChange,
            }}
        />
    )
}

export default CreationUploadUsernameField
